/**
 * Response Builder App Shell
 * 
 * Per CANON.md Section 8.1:
 * - Left sidebar navigation (registry-driven)
 * - Top header (page title + primary CTA + subscription status)
 * - Main content outlet
 */

import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';

export default function AppShell() {
  return (
    <div className="flex h-screen bg-neutral-50">
      {/* Left sidebar */}
      <Sidebar />
      
      {/* Main content area */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Top header - minimal for now */}
        <header className="bg-white border-b border-neutral-200 px-6 py-4">
          <h1 className="text-xl font-semibold text-neutral-900">Response Builder</h1>
        </header>
        
        {/* Page content */}
        <main className="flex-1 overflow-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
